import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import {
  GraduationCap,
  X,
  LogIn,
  Search,
  Lock,
  Calculator,
  Type,
  FlaskConical,
  Languages,
  Globe,
  Layers, // Ikon untuk Kelas
} from "lucide-react";

// IMPORT STYLE DARI GLOBAL
import { styles } from "../utils/globalStyles";

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [showLoginForm, setShowLoginForm] = useState(false);
  const [listMateri, setListMateri] = useState([]);
  const [listMapel, setListMapel] = useState([]);

  // STATE FILTER
  const [searchJudul, setSearchJudul] = useState("");
  const [filterMapel, setFilterMapel] = useState("");
  const [filterJenis, setFilterJenis] = useState("");
  const [filterKelas, setFilterKelas] = useState("");

  const [showPremiumModal, setShowPremiumModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  // Opsi Kelas
  const opsiKelas = [
    "TK",
    "1 SD",
    "2 SD",
    "3 SD",
    "4 SD",
    "5 SD",
    "6 SD",
    "7 SMP",
    "8 SMP",
    "9 SMP",
    "10 SMA",
    "11 SMA",
    "12 SMA",
    "Umum",
  ];

  useEffect(() => {
    async function fetchData() {
      const { data: dataMateri } = await supabase
        .from("materi")
        .select("*")
        .order("urutan", { ascending: true })
        .order("id", { ascending: false });
      setListMateri(dataMateri || []);
      const { data: dataMapel } = await supabase
        .from("mata_pelajaran")
        .select("*")
        .order("nama_mapel");
      setListMapel(dataMapel || []);
    }
    fetchData();
  }, []);

  // ... (import lainnya tetap sama)

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");

    try {
      // 1. Cek Username & Password ke Supabase
      const { data, error } = await supabase
        .from("akun")
        .select("*")
        .eq("username", username)
        .eq("password", password) // Catatan: Di app nyata, gunakan hashing!
        .single();

      if (error || !data) {
        setErrorMsg("Username atau Password salah.");
      } else {
        // --- LOGIKA KEAMANAN TAMBAHAN ---

        // Cek apakah yang login adalah Admin/Kepala/Operator (Bukan Siswa)
        if (["admin", "kepala", "operator"].includes(data.role)) {
          // Cek Kunci di LocalStorage
          const deviceToken = localStorage.getItem("TRUSTED_DEVICE_KEY");

          if (deviceToken !== "VERIFIED_ACCESS_GRANTED") {
            // JIKA KUNCI TIDAK ADA / SALAH -> TOLAK!
            setErrorMsg(
              "⛔ AKSES DITOLAK: Perangkat ini tidak dikenali sebagai perangkat Admin. Silakan hubungi IT."
            );
            setLoading(false);
            return; // Stop proses login
          }
        }

        // Jika lolos pengecekan (atau jika user adalah siswa), izinkan masuk
        onLogin({
          nama: data.nama_lengkap,
          role: data.role,
          username: data.username,
        });
      }
    } catch (err) {
      console.error(err);
      setErrorMsg("Terjadi gangguan koneksi.");
    }
    setLoading(false);
  };

  const handleMateriClick = (item) => {
    if (item.is_public === false) setShowPremiumModal(true);
    else setPreviewUrl(item.link_url);
  };

  const getMapelIcon = (mapel) => {
    const m = mapel ? mapel.toLowerCase() : "";
    if (m.includes("matematika") || m.includes("math"))
      return <Calculator size={18} />;
    if (m.includes("indonesia") || m.includes("baca"))
      return <Type size={18} />;
    if (m.includes("ipa") || m.includes("sains") || m.includes("fisika"))
      return <FlaskConical size={18} />;
    if (m.includes("inggris") || m.includes("english"))
      return <Languages size={18} />;
    return <Globe size={18} />;
  };

  // LOGIKA FILTER
  const filteredMateri = listMateri.filter((item) => {
    const matchJudul = item.judul
      .toLowerCase()
      .includes(searchJudul.toLowerCase());
    const matchMapel = filterMapel ? item.mata_pelajaran === filterMapel : true;
    const matchJenis = filterJenis
      ? (item.jenis || "Materi") === filterJenis
      : true;
    const itemKelas = item.kelas || "Umum";
    const matchKelas = filterKelas ? itemKelas === filterKelas : true;

    return matchJudul && matchMapel && matchJenis && matchKelas;
  });

  return (
    <div style={styles.container}>
      {/* NAVBAR */}
      <div style={styles.navbar}>
        <div style={styles.brandName}>
          <GraduationCap size={16} /> Kelas Aksara
        </div>
        <button
          style={styles.loginBtnSmall}
          onClick={() => setShowLoginForm(!showLoginForm)}
        >
          {showLoginForm ? <X size={12} /> : <LogIn size={12} />}
          {showLoginForm ? "Tutup" : "Masuk"}
        </button>
      </div>

      {/* HEADER HERO */}
      <div style={styles.headerHero}>
        <h1
          style={{
            fontSize: "20px",
            margin: "5px 0 2px 0",
            fontWeight: "700",
            letterSpacing: "-0.3px",
          }}
        >
          Portal Belajar
        </h1>
        <p
          style={{
            margin: "0",
            fontSize: "12px",
            opacity: 0.6,
            fontWeight: "400",
          }}
        >
          Materi & Latihan Soal Terpadu
        </p>
      </div>

      {/* FORM LOGIN */}
      {showLoginForm && (
        <div style={styles.loginOverlay}>
          <div style={styles.compactCard}>
            <div style={{ textAlign: "left", marginBottom: 15 }}>
              <h3 style={{ margin: 0, fontSize: "15px", color: "#1e293b" }}>
                Login Akun
              </h3>
              <p
                style={{
                  margin: "2px 0 0 0",
                  fontSize: "11px",
                  color: "#64748b",
                }}
              >
                Masukkan kredensial Anda untuk melanjutkan.
              </p>
            </div>
            <form onSubmit={handleLogin}>
              <input
                style={styles.inputField}
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
              <input
                style={styles.inputField}
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {errorMsg && (
                <div
                  style={{
                    color: "#EF4444",
                    fontSize: "11px",
                    marginBottom: "10px",
                    textAlign: "left",
                    fontWeight: "500",
                  }}
                >
                  ⚠️ {errorMsg}
                </div>
              )}
              <button
                type="submit"
                style={styles.primaryBtn}
                disabled={loading}
              >
                {loading ? "Memproses..." : "Masuk Sekarang"}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* AREA MATERI */}
      <div style={{ padding: "20px" }}>
        {/* SEARCH & FILTER */}
        <div
          style={{
            background: "white",
            padding: "12px",
            borderRadius: "16px",
            marginBottom: "20px",
            border: "1px solid #F1F5F9",
            boxShadow: "0 2px 5px rgba(0,0,0,0.01)",
          }}
        >
          <div style={{ position: "relative", marginBottom: "10px" }}>
            <Search
              size={14}
              color="#94a3b8"
              style={{ position: "absolute", left: 10, top: 10 }}
            />
            <input
              style={{
                width: "100%",
                padding: "8px 8px 8px 32px",
                borderRadius: "8px",
                border: "1px solid #E2E8F0",
                outline: "none",
                fontSize: "12px",
                boxSizing: "border-box",
                background: "#f8fafc",
              }}
              placeholder="Cari materi..."
              value={searchJudul}
              onChange={(e) => setSearchJudul(e.target.value)}
            />
          </div>

          <div style={styles.filterContainer}>
            <select
              style={{
                ...styles.filterSelect,
                fontWeight: "bold",
                color: "#2563EB",
              }}
              value={filterKelas}
              onChange={(e) => setFilterKelas(e.target.value)}
            >
              <option value="">Semua Tingkat</option>
              {opsiKelas.map((k) => (
                <option key={k} value={k}>
                  {k}
                </option>
              ))}
            </select>

            <select
              style={styles.filterSelect}
              value={filterMapel}
              onChange={(e) => setFilterMapel(e.target.value)}
            >
              <option value="">Mapel</option>
              {listMapel.map((m) => (
                <option key={m.id} value={m.nama_mapel}>
                  {m.nama_mapel}
                </option>
              ))}
            </select>
            <select
              style={styles.filterSelect}
              value={filterJenis}
              onChange={(e) => setFilterJenis(e.target.value)}
            >
              <option value="">Tipe</option>
              <option value="Materi">📖 Materi</option>
              <option value="Latihan">📝 Latihan</option>
            </select>
          </div>
        </div>

        {/* LIST ITEM */}
        <div
          style={{
            fontSize: "11px",
            fontWeight: "700",
            color: "#94a3b8",
            marginBottom: "10px",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
        >
          Materi Tersedia ({filteredMateri.length})
        </div>

        <div style={{ display: "grid", gap: 8 }}>
          {filteredMateri.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                padding: 30,
                color: "#94a3b8",
                fontSize: 13,
                border: "1px dashed #cbd5e1",
                borderRadius: 12,
              }}
            >
              Tidak ada materi ditemukan.
            </div>
          ) : (
            filteredMateri.map((item) => {
              const isPremium = item.is_public === false;
              const iconBg = isPremium ? "#FFF7ED" : "#F1F5F9";
              const iconColor = isPremium ? "#B45309" : "#334155";
              const itemKelas = item.kelas || "Umum";

              return (
                <div
                  key={item.id}
                  onClick={() => handleMateriClick(item)}
                  style={{
                    background: "white",
                    padding: "14px",
                    borderRadius: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    border: "1px solid #F1F5F9",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.01)",
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: "10px",
                      background: iconBg,
                      color: iconColor,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    {isPremium ? (
                      <Lock size={18} />
                    ) : (
                      getMapelIcon(item.mata_pelajaran)
                    )}
                  </div>

                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: "13px",
                        color: "#1e293b",
                        marginBottom: 2,
                      }}
                    >
                      {item.judul}
                    </div>
                    <div
                      style={{
                        fontSize: "11px",
                        color: "#64748B",
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <span
                        style={{
                          background: "#F3E8FF",
                          color: "#7E22CE",
                          padding: "2px 6px",
                          borderRadius: "6px",
                          fontWeight: "700",
                          fontSize: "10px",
                        }}
                      >
                        {itemKelas}
                      </span>
                      <span>{item.mata_pelajaran || "Umum"}</span>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      {/* MODAL & PREVIEW */}
      {showPremiumModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalCard}>
            <div
              style={{
                width: 45,
                height: 45,
                background: "#FFF7ED",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 15px auto",
              }}
            >
              <Lock size={20} color="#F59E0B" />
            </div>
            <h3
              style={{
                fontSize: "15px",
                margin: "0 0 8px 0",
                color: "#1e293b",
              }}
            >
              Konten Premium
            </h3>
            <p
              style={{
                fontSize: "13px",
                color: "#64748B",
                margin: "0 0 20px 0",
                lineHeight: "1.4",
              }}
            >
              Login diperlukan untuk mengakses materi ini.
            </p>
            <div style={{ display: "grid", gap: 8 }}>
              <button
                onClick={() => {
                  setShowPremiumModal(false);
                  setShowLoginForm(true);
                }}
                style={styles.primaryBtn}
              >
                Login
              </button>
              <button
                onClick={() => setShowPremiumModal(false)}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#64748B",
                  fontSize: 12,
                  cursor: "pointer",
                  padding: 8,
                }}
              >
                Batal
              </button>
            </div>
          </div>
        </div>
      )}

      {previewUrl && (
        <div style={styles.modalOverlay}>
          <div
            style={{ position: "absolute", top: 20, right: 20, zIndex: 10001 }}
          >
            <button
              onClick={() => setPreviewUrl(null)}
              style={{
                background: "white",
                border: "none",
                borderRadius: "50%",
                width: 36,
                height: 36,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <X size={20} color="#333" />
            </button>
          </div>
          <div
            style={{
              width: "90%",
              maxWidth: "800px",
              height: "80vh",
              background: "white",
              borderRadius: "16px",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <iframe
              src={previewUrl}
              title="Preview"
              width="100%"
              height="100%"
              style={{ border: "none" }}
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
}
